import { announceToScreenReader } from '../utils/accessibility';

export const useAccessibility = () => {
  const announce = (message: string) => {
    announceToScreenReader(message);
  };

  return { announce };
};
